import './NotFound.css';

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SeoHead } from 'components';
import Logo from '../../Logo/Logo';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="notfound-page">
      <SeoHead title="Page Not Found" noIndex />
      <header className="notfound-navbar">
        <button
          type="button"
          className="notfound-logo-btn"
          onClick={() => navigate('/')}
        >
          <Logo light />
        </button>
      </header>

      <div className="notfound-content">
        <div className="notfound-card">
          <div className="notfound-code">404</div>
          <h1 className="notfound-title">Page Not Found</h1>
          <p className="notfound-text">
            The page you&apos;re looking for doesn&apos;t exist or may have
            been moved.
          </p>
          <button
            type="button"
            className="notfound-btn"
            onClick={() => navigate('/')}
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;